import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-cart-coupon',
    template: `
    <form [formGroup]="form" (submit)="addNote()">
      <div class="modal-header">
        <h4 class="modal-title" i18n>Notiz</h4>
        <button type="button" class="btn-close" aria-label="Close" i18n-aria-label
                (click)="activeModal.close()"></button>
      </div>
      <div class="modal-body">
        <textarea class="form-control" ngbAutofocus [formControl]="noteControl"></textarea>
      </div>
      <div
        class="modal-footer justify-content-center align-items-center justify-content-md-between flex-column-reverse flex-md-row p-3 p-md-4">
        <button type="button" class="btn btn-lg btn-danger w-100 w-md-auto mb-3 mb-md-0"
                (click)="removeNote()" i18n [disabled]="loading" [appLoadingOverlay]="loading">Löschen
        </button>
        <button type="submit" class="btn btn-lg btn-info w-100 w-md-auto" i18n
                [disabled]="loading || noteControl.invalid" [appLoadingOverlay]="loading">Änderungen speichern
        </button>
      </div>
    </form>
  `,
    standalone: false
})
export class NotesModalComponent {
  noteControl = new UntypedFormControl(null, [Validators.required]);
  form = new UntypedFormGroup({
    note: this.noteControl,
  });
  loading = false;

  constructor(public activeModal: NgbActiveModal,
              private readonly dataService: DataService) {

    this.noteControl.setValue(dataService.cart?.note);
  }

  async addNote() {
    if (!this.form.valid) {
      return;
    }

    this.loading = true;

    try {
      await this.dataService.updateCartNote(this.noteControl.value);
      this.activeModal.close();
    } finally {
      this.loading = false;
    }
  }

  async removeNote() {
    this.loading = true;
    try {
      await this.dataService.updateCartNote(null);
      this.activeModal.close();
    } finally {
      this.loading = false;
    }
  }
}
